<template>
    <Loading
        :is-loading="isLoading"
        :text="processingText"
    />
    <form
        v-if="to === 'GD'"
        id="goToGD"
        method="post"
        :action="gd.url"
        hidden
    >
        <input
            name="id"
            type="text"
            :value="gd.id"
        >
        <input
            name="myId"
            type="text"
            :value="gd.myId"
        >
        <input
            name="pwd"
            type="text"
            :value="gd.pwd"
        >
        <input
            name="NewPwd"
            type="text"
            :value="gd.newPwd"
        >
    </form>
</template>
<script>
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getRedirectGD } from '@/apis/redirect';
import routeName from '@/router/constant.js';
import Loading from '@/components/Loading.vue';

export default {
    components: {
        Loading,
    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const isLoading = ref(true);
        const processingText = ref('');
        const gd = ref({});
        const to = route.query.to;
        // 進入舊版線上交易專區
        const goToGD = (token) => {
            getRedirectGD(token).then((response) => {
                const data = response.data;
                gd.value = {
                    id: data.id,
                    myId: data.myId,
                    pwd: data.pwd,
                    newPwd: data.newPwd,
                    url: data.url
                };
                setTimeout(() => {
                    const form = document.getElementById('goToGD');
                    form.submit();
                }, 500);
            });
        };
        if (to === 'GD') {
            processingText.value = '進入網頁版線上交易專區';
            const token = route.query.token;
            setTimeout(() => {
                goToGD(token);
            }, 500);
        } else {
            processingText.value = '';
            router.push({ name: routeName.NOTFOUND });
        }
        return {
            isLoading,
            processingText,
            gd,
            to
        };
    },
};

</script>
